import { MDSSkeleton } from "@/mds/components/loading/skeleton";
import { MDSMediaQueries } from "@/mds/foundations";
import styled from "@emotion/styled";

export const NoteSkeleton = () => {
  return (
    <Container>
      <MDSSkeleton height={30} delay={0} />

      <ContentSkeleton>
        <MDSSkeleton height={16} delay={300} />
        <MDSSkeleton height={16} delay={400} />
        <MDSSkeleton height={16} delay={500} />
      </ContentSkeleton>

      <ContentSkeleton>
        <MDSSkeleton height={16} delay={600} />
        <MDSSkeleton height={16} delay={700} />
        <MDSSkeleton height={16} delay={800} />
        <MDSSkeleton height={16} delay={900} />
      </ContentSkeleton>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  gap: 24px;
  padding-top: 40px;
  padding-left: 28px;
  padding-right: 28px;
  padding-bottom: 200px;

  ${MDSMediaQueries.rules.tablet} {
    padding-top: 40px;
    padding-left: 28px;
    padding-right: 28px;
    padding-bottom: 100px;
  }

  ${MDSMediaQueries.rules.phone} {
    padding-top: 40px;
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 100px;
  }
`;

const ContentSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
